import DashboardHomePage, {
  DashboardHomeErrorBoundary,
} from '@/common/pages/(private)/(dashboard)';

export default function Page() {
  return <DashboardHomePage />;
}

export function ErrorBoundary() {
  return <DashboardHomeErrorBoundary />;
}
